//FOR cancel digital order
export const CANCEL_DIGITAL_ORDER_ERROR = 'CANCEL_DIGITAL_ORDER_ERROR';
export const CANCEL_DIGITAL_ORDER_REQUEST = 'CANCEL_DIGITAL_ORDER_REQUEST';
export const CANCEL_DIGITAL_ORDER_SUCCESS = 'CANCEL_DIGITAL_ORDER_SUCCESS';
